import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { IconButton } from '@material-ui/core';

import { LockIcon, UnlockIcon } from '../../../../../../components/icon/solid';
import { MediaStyles } from '../styles';
import { lockMediaToProjectRequest } from '../../../../../../store/modules/articles/actions';

type Props = {
  id: number;
  lock: boolean;
};

const LockAction = ({ id, lock }: Props) => {
  const classes = MediaStyles();
  const dispatch = useDispatch();
  const [lockMedia, setLockMedia] = useState(lock);

  const clickHandler = useCallback(() => {
    setLockMedia(!lockMedia);
    dispatch(lockMediaToProjectRequest({
      id,
      lock_media_to_project: !lockMedia,
    }));
  }, [dispatch, id, lockMedia, setLockMedia]);

  return (
    <IconButton onClick={clickHandler} className={classes.actionButton}>
      {lockMedia ? <LockIcon className={classes.lockIcon} /> : <UnlockIcon className={classes.lockIcon} />}
    </IconButton>
  );
};

export default LockAction;
